// Module
var code = "<ul> <li> <a href=\"/signIn\" target=\"_blank\">For Borrowers</a></li> <li> <a href=\"https://am.partners.aessuccess.org/partnersB2Bsso/login.htm\">For Schools or Lenders</a></li> </ul> ";
// Exports
export default code;